<div class="top-section">
  <div class="row ">
    <div class="dispatcher-header">
      <div class="dispatcher-date">
        <span class="dispatcher-title">  Dispatcher</span> <br> {{date}}
      </div>
      <div class="dispatcher-time">
        {{time}}
      </div>
      <div class="full-screen">
        <ng-container *ngIf="!fullScreen">
          <mat-icon class="fullscreen-icon" (click)="maximize()">fullscreen</mat-icon>
        </ng-container>
        <ng-container *ngIf="fullScreen">
          <mat-icon class="fullscreen-icon" (click)="maximize()">fullscreen_exit</mat-icon>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="dispatcher-container container">
  <div class="row ms-0 py-3 service-information">
    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 service-information-title">Driftinformation</div>
    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
      <span class="service-information-text">{{serviceInformationTextAreaValue}}</span>
      <span class="service-information-updated">Uppdaterad: {{updated | date: 'HH:mm'}}</span>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1 text-end">
      <button *ngIf="!serviceInformationInputDisabled" class="btn btn-primary edit-service-information" (click)="toggleModal()">
        <svg width="28" height="28" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9442 0L0 12.9445V18H5.05548L18 5.05584L12.9442 0ZM12.9442 1.85724L16.1428 5.05584L14.1167 7.08228L10.9177 3.88332L12.9442 1.85724ZM4.51188 16.6867H1.31292V13.4881L9.98928 4.81212L13.1879 8.01072L4.51188 16.6867Z" fill="#0F7CAC" />
        </svg>
      </button>
    </div>
    <div id="myModal" class="modal fade">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Redigera Driftinformation</h5>
            <button type="button" class="btn-close" (click)="toggleModal()" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <textarea placeholder="Inga störningar" rows="5" maxlength="200" [(ngModel)]="serviceInformationTextAreaValue" [disabled]="serviceInformationInputDisabled" id="myInput" autofocus></textarea>
            <div class="d-flex justify-content-between align-items-center">
              <span class="service-information-updated">{{serviceInformationTextAreaValue.length}}/200</span>
              <!--*ngIf="dirty()"-->
              <button mat-flat-button color="primary" type="button" class="update_button" (click)="update()">
                Uppdatera
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
      <!-- ----------LANDSIDE Column---------- -->
      <mat-table matSort [dataSource]="dataSourceLandside" (matSortChange)="sortData($event, 'LAND')" matSortActive="activity" matSortDirection="asc">
        <ng-container matColumnDef="name">

          <!-- Name Column -->
          <mat-header-cell *matHeaderCellDef mat-sort-header="name" class="flex-4 header-cell"> Förare </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-4 landside-cell">
            <span class="mobile-label mob-user-icon">
              <svg *ngIf="element.checkedin" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 4.5C4.5 6.981 6.519 9 9 9C11.481 9 13.5 6.981 13.5 4.5C13.5 2.019 11.481 0 9 0C6.519 0 4.5 2.019 4.5 4.5ZM17 19H18V18C18 14.141 14.859 11 11 11H7C3.14 11 0 14.141 0 18V19H17Z" fill="#2D6E78" />
              </svg>
              <svg *ngIf="!element.checkedin" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 4.5C4.5 6.981 6.519 9 9 9C11.481 9 13.5 6.981 13.5 4.5C13.5 2.019 11.481 0 9 0C6.519 0 4.5 2.019 4.5 4.5ZM17 19H18V18C18 14.141 14.859 11 11 11H7C3.14 11 0 14.141 0 18V19H17Z" fill="#860022" />
              </svg>
            </span>
            <span class="user-icon">
              <mat-icon *ngIf="element.checkedin" class="checkedin">person</mat-icon>
              <mat-icon *ngIf="!element.checkedin && !element.lateToWork" class="not-checkedin">person</mat-icon>
              <mat-icon *ngIf="!element.checkedin && element.lateToWork" class="blink late-checkedin">person</mat-icon>
            </span>
            <span class="dots-linebreak user-action-name">  {{element.name}}</span>
          </mat-cell>
        </ng-container>

        <!-- Uppdrag Column -->
        <ng-container matColumnDef="subtype">
          <mat-header-cell *matHeaderCellDef mat-sort-header="activity" class="flex-1 header-cell subtype-heared-cell">  <mat-icon>route</mat-icon> </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-1 landside-cell">
            <span class="mobile-label activity-Name">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#868F93" d="M9 21q-1.65 0-2.825-1.175T5 17V8.825Q4.125 8.5 3.563 7.738T3 6q0-1.25.875-2.125T6 3t2.125.875T9 6q0 .975-.562 1.738T7 8.825V17q0 .825.588 1.413T9 19t1.413-.587T11 17V7q0-1.65 1.175-2.825T15 3t2.825 1.175T19 7v8.175q.875.325 1.438 1.088T21 18q0 1.25-.875 2.125T18 21t-2.125-.875T15 18q0-.975.563-1.75T17 15.175V7q0-.825-.587-1.412T15 5t-1.412.588T13 7v10q0 1.65-1.175 2.825T9 21" /></svg>
            </span>
            {{element.activityName}}
          </mat-cell>
        </ng-container>

        <!-- Buss Column -->
        <ng-container matColumnDef="buss">
          <mat-header-cell *matHeaderCellDef mat-sort-header="buss" class="flex-2 header-cell">  Buss </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-2 landside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 336 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M292.962 414.091C278.273 414.091 266.368 401.189 266.368 385.274C266.368 369.352 278.273 356.45 292.962 356.45C307.651 356.45 319.563 369.352 319.563 385.274C319.563 401.189 307.651 414.091 292.962 414.091ZM35.978 327.498C26.1854 327.498 18.2439 318.89 18.2439 308.282V135.063C18.2439 124.448 26.1854 115.847 35.978 115.847H302.346C312.138 115.847 320.073 124.448 320.073 135.063V308.276C320.073 318.883 312.138 327.492 302.346 327.492H35.4616H35.978V327.498ZM44.8451 414.098C30.1561 414.098 18.2439 401.196 18.2439 385.281C18.2439 369.359 30.1561 356.457 44.8451 356.457C59.5341 356.457 71.4396 369.359 71.4396 385.281C71.4396 401.196 59.5341 414.098 44.8451 414.098ZM62.5793 58.0642H275.617C285.41 58.0642 293.351 66.6658 293.351 77.2803C293.351 87.8947 285.41 96.4963 275.617 96.4963H62.1902C52.3975 96.4963 44.4561 87.8947 44.4561 77.2803C44.4561 66.6658 52.3975 58.0642 62.1902 58.0642H62.5793ZM278.313 38.9891L261.867 12.6743C256.904 4.73027 248.62 -0.0200648 239.766 6.37128e-05H97.6585C88.8049 -0.0200648 80.5213 4.73027 75.5579 12.6743L59.239 38.5731C26.0982 40.2773 0.0335366 69.873 0 105.816V452.517H17.7341V486.071C17.7341 493.767 23.4823 500 30.5787 500H57.1799C64.2762 500 70.0311 493.76 70.0311 486.071V452.523H265.335V486.071C265.335 493.767 271.09 500 278.186 500H304.787C311.883 500 317.632 493.76 317.632 486.071V452.523H335.366V106.232C335.413 71.1411 310.589 41.8876 278.313 38.9824V38.9891Z" fill="#868F93" />
              </svg>
            </span>
            {{element.buss}}
          </mat-cell>
        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="schedule">
          <mat-header-cell *matHeaderCellDef mat-sort-header="schedule" class="flex-3 header-cell">  Tid </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 landside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M249.969 36.3896C367.773 36.3896 463.569 132.185 463.569 249.99C463.569 367.794 367.773 463.59 249.969 463.59C132.164 463.59 36.3686 367.794 36.3686 249.99C36.3686 132.185 132.164 36.3896 249.969 36.3896ZM249.969 0C111.894 0 0 111.936 0 249.99C0 388.043 111.936 500 250.01 500C388.064 500 500 388.064 500 249.99C499.979 111.936 388.022 0 249.948 0H249.969ZM355.532 367.627C351.968 367.627 348.384 366.537 345.198 364.378L241.982 293.108C237.077 289.712 234.121 284.094 234.121 278.141V118.182C234.121 108.121 242.255 99.9874 252.295 99.9874C262.357 99.9874 270.511 108.121 270.511 118.182V268.583L365.908 334.465C374.167 340.146 376.221 351.465 370.561 359.745C366.998 364.818 361.338 367.606 355.553 367.606H355.532V367.627Z" fill="#868F93" />
              </svg>
            </span>
            {{element.start|date: 'HH:mm'}} - {{element.end|date: 'HH:mm'}}
          </mat-cell>
        </ng-container>


        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="flex-3 header-cell">  Anteckning </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 landside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 417 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 500V136.364C0 123.864 4.53704 113.167 13.6111 104.273C22.6852 95.3788 33.5802 90.9242 46.2963 90.9091H277.778C290.509 90.9091 301.412 95.3636 310.486 104.273C319.56 113.182 324.089 123.879 324.074 136.364V500L162.037 431.818L0 500ZM370.37 431.818V45.4545H69.4444V0H370.37C383.102 0 394.005 4.45455 403.079 13.3636C412.153 22.2727 416.682 32.9697 416.667 45.4545V431.818H370.37Z" fill="#868F93" />
              </svg>
            </span>
            <span class="dots-linebreak">  {{element.comment}}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="['subtype', 'name', 'buss', 'schedule', 'comment']" class="landside-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['subtype', 'name', 'buss', 'schedule', 'comment']" class="landside-row"></mat-row>
      </mat-table>

    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
      <!-- ----------AIRSIDE Column---------- -->
      <mat-table matSort [dataSource]="dataSourceAirside" (matSortChange)="sortData($event, 'AIR')" matSortActive="schedule" matSortDirection="asc">
        <ng-container matColumnDef="name">

          <!-- Name Column -->
          <mat-header-cell *matHeaderCellDef mat-sort-header="airsideName" class="flex-4 header-cell"> Förare </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-4 airside-cell">
            <span class="mobile-label mob-user-icon">
              <svg *ngIf="element.checkedin" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 4.5C4.5 6.981 6.519 9 9 9C11.481 9 13.5 6.981 13.5 4.5C13.5 2.019 11.481 0 9 0C6.519 0 4.5 2.019 4.5 4.5ZM17 19H18V18C18 14.141 14.859 11 11 11H7C3.14 11 0 14.141 0 18V19H17Z" fill="#2D6E78" />
              </svg>
              <svg *ngIf="!element.checkedin" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 4.5C4.5 6.981 6.519 9 9 9C11.481 9 13.5 6.981 13.5 4.5C13.5 2.019 11.481 0 9 0C6.519 0 4.5 2.019 4.5 4.5ZM17 19H18V18C18 14.141 14.859 11 11 11H7C3.14 11 0 14.141 0 18V19H17Z" fill="#860022" />
              </svg>
            </span>
            <span class="user-icon">
              <mat-icon *ngIf="element.checkedin" class="checkedin">person</mat-icon>
              <mat-icon *ngIf="!element.checkedin && !element.lateToWork" class="not-checkedin">person</mat-icon>
              <mat-icon *ngIf="!element.checkedin && element.lateToWork" class="blink late-checkedin">person</mat-icon>
            </span>
            <span class="dots-linebreak user-action-name">  {{element.name}}</span>
          </mat-cell>
        </ng-container>

        <!-- Buss Column -->
        <ng-container matColumnDef="buss">
          <mat-header-cell *matHeaderCellDef mat-sort-header="buss" class="flex-2 header-cell">  Buss </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-2 airside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 336 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M292.962 414.091C278.273 414.091 266.368 401.189 266.368 385.274C266.368 369.352 278.273 356.45 292.962 356.45C307.651 356.45 319.563 369.352 319.563 385.274C319.563 401.189 307.651 414.091 292.962 414.091ZM35.978 327.498C26.1854 327.498 18.2439 318.89 18.2439 308.282V135.063C18.2439 124.448 26.1854 115.847 35.978 115.847H302.346C312.138 115.847 320.073 124.448 320.073 135.063V308.276C320.073 318.883 312.138 327.492 302.346 327.492H35.4616H35.978V327.498ZM44.8451 414.098C30.1561 414.098 18.2439 401.196 18.2439 385.281C18.2439 369.359 30.1561 356.457 44.8451 356.457C59.5341 356.457 71.4396 369.359 71.4396 385.281C71.4396 401.196 59.5341 414.098 44.8451 414.098ZM62.5793 58.0642H275.617C285.41 58.0642 293.351 66.6658 293.351 77.2803C293.351 87.8947 285.41 96.4963 275.617 96.4963H62.1902C52.3975 96.4963 44.4561 87.8947 44.4561 77.2803C44.4561 66.6658 52.3975 58.0642 62.1902 58.0642H62.5793ZM278.313 38.9891L261.867 12.6743C256.904 4.73027 248.62 -0.0200648 239.766 6.37128e-05H97.6585C88.8049 -0.0200648 80.5213 4.73027 75.5579 12.6743L59.239 38.5731C26.0982 40.2773 0.0335366 69.873 0 105.816V452.517H17.7341V486.071C17.7341 493.767 23.4823 500 30.5787 500H57.1799C64.2762 500 70.0311 493.76 70.0311 486.071V452.523H265.335V486.071C265.335 493.767 271.09 500 278.186 500H304.787C311.883 500 317.632 493.76 317.632 486.071V452.523H335.366V106.232C335.413 71.1411 310.589 41.8876 278.313 38.9824V38.9891Z" fill="#868F93" />
              </svg>
            </span>
            {{element.buss}}
          </mat-cell>
        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="schedule">
          <mat-header-cell *matHeaderCellDef mat-sort-header="schedule" class="flex-3 header-cell">  Tid </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 airside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M249.969 36.3896C367.773 36.3896 463.569 132.185 463.569 249.99C463.569 367.794 367.773 463.59 249.969 463.59C132.164 463.59 36.3686 367.794 36.3686 249.99C36.3686 132.185 132.164 36.3896 249.969 36.3896ZM249.969 0C111.894 0 0 111.936 0 249.99C0 388.043 111.936 500 250.01 500C388.064 500 500 388.064 500 249.99C499.979 111.936 388.022 0 249.948 0H249.969ZM355.532 367.627C351.968 367.627 348.384 366.537 345.198 364.378L241.982 293.108C237.077 289.712 234.121 284.094 234.121 278.141V118.182C234.121 108.121 242.255 99.9874 252.295 99.9874C262.357 99.9874 270.511 108.121 270.511 118.182V268.583L365.908 334.465C374.167 340.146 376.221 351.465 370.561 359.745C366.998 364.818 361.338 367.606 355.553 367.606H355.532V367.627Z" fill="#868F93" />
              </svg>
            </span>
            {{element.start|date: 'HH:mm'}} - {{element.end|date: 'HH:mm'}}
          </mat-cell>
        </ng-container>


        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="flex-3 header-cell">  Anteckning </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 airside-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 417 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 500V136.364C0 123.864 4.53704 113.167 13.6111 104.273C22.6852 95.3788 33.5802 90.9242 46.2963 90.9091H277.778C290.509 90.9091 301.412 95.3636 310.486 104.273C319.56 113.182 324.089 123.879 324.074 136.364V500L162.037 431.818L0 500ZM370.37 431.818V45.4545H69.4444V0H370.37C383.102 0 394.005 4.45455 403.079 13.3636C412.153 22.2727 416.682 32.9697 416.667 45.4545V431.818H370.37Z" fill="#868F93" />
              </svg>
            </span>
            <span class="dots-linebreak">  {{element.comment}}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="['name', 'buss', 'schedule', 'comment']" class="airside-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['name', 'buss', 'schedule', 'comment']" class="airside-row"></mat-row>
      </mat-table>

    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
      <!-- ----------OTHER---------- -->
      <mat-table matSort [dataSource]="dataSourceOther" (matSortChange)="sortData($event, 'LKOO')" matSortActive="schedule" matSortDirection="asc">
        <ng-container matColumnDef="name">

          <!-- Name Column -->
          <mat-header-cell *matHeaderCellDef mat-sort-header="name" class="flex-4 header-cell"> Busstrafikledare </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-4 other-cell">
            <span class="dots-linebreak user-action-name">  {{element.name}}</span>
          </mat-cell>
        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="schedule">
          <mat-header-cell *matHeaderCellDef mat-sort-header="schedule" class="flex-3 header-cell">  Tid </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 other-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M249.969 36.3896C367.773 36.3896 463.569 132.185 463.569 249.99C463.569 367.794 367.773 463.59 249.969 463.59C132.164 463.59 36.3686 367.794 36.3686 249.99C36.3686 132.185 132.164 36.3896 249.969 36.3896ZM249.969 0C111.894 0 0 111.936 0 249.99C0 388.043 111.936 500 250.01 500C388.064 500 500 388.064 500 249.99C499.979 111.936 388.022 0 249.948 0H249.969ZM355.532 367.627C351.968 367.627 348.384 366.537 345.198 364.378L241.982 293.108C237.077 289.712 234.121 284.094 234.121 278.141V118.182C234.121 108.121 242.255 99.9874 252.295 99.9874C262.357 99.9874 270.511 108.121 270.511 118.182V268.583L365.908 334.465C374.167 340.146 376.221 351.465 370.561 359.745C366.998 364.818 361.338 367.606 355.553 367.606H355.532V367.627Z" fill="#868F93" />
              </svg>
            </span>
            {{element.start|date: 'HH:mm'}} - {{element.end|date: 'HH:mm'}}
          </mat-cell>
        </ng-container>


        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="flex-3 header-cell">  Anteckning </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 other-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 417 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 500V136.364C0 123.864 4.53704 113.167 13.6111 104.273C22.6852 95.3788 33.5802 90.9242 46.2963 90.9091H277.778C290.509 90.9091 301.412 95.3636 310.486 104.273C319.56 113.182 324.089 123.879 324.074 136.364V500L162.037 431.818L0 500ZM370.37 431.818V45.4545H69.4444V0H370.37C383.102 0 394.005 4.45455 403.079 13.3636C412.153 22.2727 416.682 32.9697 416.667 45.4545V431.818H370.37Z" fill="#868F93" />
              </svg>
            </span>
            <span class="dots-linebreak">  {{element.comment}}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="['name', 'schedule', 'comment']" class="other-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['name', 'schedule', 'comment']" class="other-row"></mat-row>
      </mat-table>

    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
      <!-- ----------KOOR---------- -->
      <mat-table matSort [dataSource]="dataSourceKoor" (matSortChange)="sortData($event, 'KOOR')" matSortActive="schedule" matSortDirection="asc">
        <ng-container matColumnDef="name">

          <!-- Name Column -->
          <mat-header-cell *matHeaderCellDef mat-sort-header="name" class="flex-4 header-cell"> Busskoordinator </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-4 koor-cell">
            <span class="dots-linebreak user-action-name">  {{element.name}}</span>
          </mat-cell>
        </ng-container>

        <!-- Uppdrag Column -->
        <ng-container matColumnDef="skillString">
          <mat-header-cell *matHeaderCellDef mat-sort-header="skillString" class="flex-3 header-cell">  Uppdrag </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 koor-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.72933 13.5C8.80107 13.5 7.91084 13.1313 7.25446 12.4749C6.59808 11.8185 6.22933 10.9283 6.22933 10C6.22933 9.07174 6.59808 8.18151 7.25446 7.52513C7.91084 6.86875 8.80107 6.5 9.72933 6.5C10.6576 6.5 11.5478 6.86875 12.2042 7.52513C12.8606 8.18151 13.2293 9.07174 13.2293 10C13.2293 10.9283 12.8606 11.8185 12.2042 12.4749C11.5478 13.1313 10.6576 13.5 9.72933 13.5ZM17.1593 10.97C17.1993 10.65 17.2293 10.33 17.2293 10C17.2293 9.67 17.1993 9.34 17.1593 9L19.2693 7.37C19.4593 7.22 19.5093 6.95 19.3893 6.73L17.3893 3.27C17.2693 3.05 16.9993 2.96 16.7793 3.05L14.2893 4.05C13.7693 3.66 13.2293 3.32 12.5993 3.07L12.2293 0.420002C12.209 0.302219 12.1477 0.195429 12.0561 0.118553C11.9646 0.0416778 11.8489 -0.000319774 11.7293 1.83347e-06H7.72933C7.47933 1.83347e-06 7.26933 0.180002 7.22933 0.420002L6.85933 3.07C6.22933 3.32 5.68933 3.66 5.16933 4.05L2.67933 3.05C2.45933 2.96 2.18933 3.05 2.06933 3.27L0.0693316 6.73C-0.0606684 6.95 -0.000668302 7.22 0.189332 7.37L2.29933 9C2.25933 9.34 2.22933 9.67 2.22933 10C2.22933 10.33 2.25933 10.65 2.29933 10.97L0.189332 12.63C-0.000668302 12.78 -0.0606684 13.05 0.0693316 13.27L2.06933 16.73C2.18933 16.95 2.45933 17.03 2.67933 16.95L5.16933 15.94C5.68933 16.34 6.22933 16.68 6.85933 16.93L7.22933 19.58C7.26933 19.82 7.47933 20 7.72933 20H11.7293C11.9793 20 12.1893 19.82 12.2293 19.58L12.5993 16.93C13.2293 16.67 13.7693 16.34 14.2893 15.94L16.7793 16.95C16.9993 17.03 17.2693 16.95 17.3893 16.73L19.3893 13.27C19.5093 13.05 19.4593 12.78 19.2693 12.63L17.1593 10.97Z" fill="#868F93" />
              </svg> </span>
            {{element.skillString}}
          </mat-cell>
        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="schedule">
          <mat-header-cell *matHeaderCellDef mat-sort-header="schedule" class="flex-3 header-cell">  Tid </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 koor-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M249.969 36.3896C367.773 36.3896 463.569 132.185 463.569 249.99C463.569 367.794 367.773 463.59 249.969 463.59C132.164 463.59 36.3686 367.794 36.3686 249.99C36.3686 132.185 132.164 36.3896 249.969 36.3896ZM249.969 0C111.894 0 0 111.936 0 249.99C0 388.043 111.936 500 250.01 500C388.064 500 500 388.064 500 249.99C499.979 111.936 388.022 0 249.948 0H249.969ZM355.532 367.627C351.968 367.627 348.384 366.537 345.198 364.378L241.982 293.108C237.077 289.712 234.121 284.094 234.121 278.141V118.182C234.121 108.121 242.255 99.9874 252.295 99.9874C262.357 99.9874 270.511 108.121 270.511 118.182V268.583L365.908 334.465C374.167 340.146 376.221 351.465 370.561 359.745C366.998 364.818 361.338 367.606 355.553 367.606H355.532V367.627Z" fill="#868F93" />
              </svg>
            </span>
            {{element.start|date: 'HH:mm'}} - {{element.end|date: 'HH:mm'}}
          </mat-cell>
        </ng-container>


        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="flex-3 header-cell">  Anteckning </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-3 koor-cell">
            <span class="mobile-label">
              <svg viewBox="0 0 417 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 500V136.364C0 123.864 4.53704 113.167 13.6111 104.273C22.6852 95.3788 33.5802 90.9242 46.2963 90.9091H277.778C290.509 90.9091 301.412 95.3636 310.486 104.273C319.56 113.182 324.089 123.879 324.074 136.364V500L162.037 431.818L0 500ZM370.37 431.818V45.4545H69.4444V0H370.37C383.102 0 394.005 4.45455 403.079 13.3636C412.153 22.2727 416.682 32.9697 416.667 45.4545V431.818H370.37Z" fill="#868F93" />
              </svg>
            </span>
            <span class="dots-linebreak">  {{element.comment}}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="['name', 'skillString', 'schedule', 'comment']" class="koor-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['name', 'skillString', 'schedule', 'comment']" class="koor-row"></mat-row>
      </mat-table>

    </div>
  </div>
</div>
</div>
